import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import RiskStatement from '@/views_v2/home/components/risk-statement';
import { PageVersionTypeEnums } from '../../types';
import { pageFeatureConfig } from '../../config';

import style from './index.module.scss';

@Component({ name: 'BottomTips' })
export default class BottomTips extends Vue {
  /** 风险提示文案 */
  @Prop(String) readonly showRisk?: boolean = true;

  // 页面版本
  @Prop(String) readonly pageVersion!: PageVersionTypeEnums;

  private get featureConfig() {
    return pageFeatureConfig.get(this.pageVersion) || {};
  }

  /** 唤起app类型 */
  private get relateAppType() {
    return this.featureConfig.evokeAppType || '';
  }

  /** 臻有钱优势文字列表 */
  private defaultAdvantageList = [
    { icon: 'crystal', text: '息费透明' },
    { icon: 'fast', text: '最快30秒放款' },
    { icon: 'round', text: '循环额度' },
  ];

  private rendereRiskStatement() {
    if (this.showRisk) {
      return <RiskStatement style={{ overflow: 'hidden', width: '100vw' }} relateAppType={this.relateAppType} />;
    }

    return null;
  }

  private render() {
    const advantageList = this.featureConfig.advantageList || this.defaultAdvantageList;

    return (
      <div class={style['bottom-tips-wrapper']}>
        <div class={style['advantage-wrapper']}>
            {advantageList.map((item) => (
              <div class={style['advantage-item']}>
                  <span class={[style[`advantage-item-${item.icon}`], style['advantage-item-icon']]}></span>
                  <span class={style['advantage-item-text']}>{item.text}</span>
              </div>
            ))}
          </div>
          {/** 底部风险提示* */}
          {this.rendereRiskStatement()}
        </div>
    );
  }
}
